const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'From',
        dataIndex: 'paymentFrom',
        sorter: true,
    },
    {
        title: 'To',
        dataIndex: 'paymentTo',
        sorter: true,
    },
    {
        title: 'Transaction Type',
        dataIndex: 'transactionType',
        sorter: true,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: true,
    },
    {
        title: 'Invoice',
        dataIndex: 'invoiceUrl',
    },
    {
        title: 'Transaction Fee (%)',
        dataIndex: 'paymentGatewayFee',
        render: (value) => (value ? value : '0.0'),
        sorter: true,
    },
    {
        title: 'Transaction Date',
        dataIndex: 'transactionDate',
        render: defaultRender,
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    }

];

export default columns;